import { z } from "zod";
import { EServiceCategory, EServiceType } from "./common";
import { userBasicPublicInfoSchema } from "./user";
import { partnerResponseDtoSchema } from "./partner";
import { AdminTaskResponseDto } from "./task";

export enum EUnattendedSessionTaskStatus {
  PENDING = "PENDING",
  DONE = "DONE",
}

/**
 * Unattended session task data schema
 */
export const unattendedSessionTaskDataSchema = z.object({
  user: userBasicPublicInfoSchema,
  partner: partnerResponseDtoSchema.nullable(),
  serviceCategory: z.nativeEnum(EServiceCategory),
  serviceType: z.nativeEnum(EServiceType),
  scheduledAt: z.number(),
  city: z.string(),
});

export type IUnattendedSessionTaskData = z.infer<typeof unattendedSessionTaskDataSchema>;

/**
 * Main unattended session task interface matching backend AdminTaskDo structure
 */
export type IUnattendedSession = AdminTaskResponseDto<IUnattendedSessionTaskData>;

